import React from 'react';
import { MdInfoOutline } from 'react-icons/md';

interface Props { entidade: any; }

const formatarRaio = (metros: number) =>
  metros >= 1000 ? `${(metros / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} km` : `${metros} m`;

// Frase viva do Monitoramento de Endereço, atualizada conforme o operador mexe nos números.
const ExplicacaoPernoite: React.FC<Props> = ({ entidade }) => {
  const inicio = entidade?.horaInicio || '00:00';
  const fim = entidade?.horaFim || '05:00';
  const raio = Number(entidade?.raioMetros) || 0;
  const fora = Number(entidade?.noitesFora) || 0;
  const janela = Number(entidade?.janelaNoites) || 0;
  const resolve = Math.floor(fora / 3);

  const frase = raio > 0 && fora > 0 && janela > 0 && fora <= janela ? (
    <>
      Entre <strong>{inicio} e {fim}</strong> (no horário do endereço de cada locatário), vejo onde o
      veículo da locação está. Se em <strong>{fora} das últimas {janela} noites</strong> ele dormir a mais de{' '}
      <strong>{formatarRaio(raio)}</strong> do endereço do locatário, você é avisado. O alerta só some quando ele
      voltar a dormir no endereço ({resolve === 0 ? 'nenhuma noite fora' : `no máximo ${resolve} ${resolve === 1 ? 'noite fora' : 'noites fora'}`} em {janela}).
      Noites sem sinal do rastreador não contam.
    </>
  ) : (
    <>Preencha o raio e as noites (as noites fora não podem passar do total da janela) para ver quando o alerta será acionado.</>
  );

  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: 10,
      background: '#f4f7fb', border: '1px solid #dde5ef', borderLeft: '3px solid #1F467E',
      borderRadius: 6, padding: '10px 14px', fontSize: 13.5, color: '#33475b', lineHeight: 1.5,
    }}>
      <MdInfoOutline size={18} color="#1F467E" style={{ flexShrink: 0, marginTop: 1 }} />
      <span>{frase}</span>
    </div>
  );
};

export default ExplicacaoPernoite;
